import type {
	AnsweringArtifactUpdateEvent, Artifact, Events
} from '@types'
import { useEffect, useState } from 'react'
import type { Socket } from 'socket.io-client'

interface ArtifactSocketProps {
	chatId: string;
	artifactId: string;
	socket: Socket;
}

interface ArtifactSocketResponse {
	artifact: Artifact;
}

export function useArtifactSocket({ chatId, socket, artifactId }: ArtifactSocketProps) {
	const [socketResponse, setSocketResponse] = useState<ArtifactSocketResponse>()

	function answerArtifactUpdate(event: AnsweringArtifactUpdateEvent) {
		if (event.chatId !== chatId || artifactId !== event.artifact.id) {
			return
		}

		const { artifact } = event

		setSocketResponse({
			artifact
		})
	}

	useEffect(() => {
		socket.on<Events>('answering:artifact-update', answerArtifactUpdate)

		return (() => {
			socket.off('answering:artifact-update', answerArtifactUpdate)
		})
	}, [artifactId])

	return socketResponse
}
